const sectionLinks = [
  { name: "Home", iconClass: "fa-solid fa-house-user" },
  { name: "About", iconClass: "fa-solid fa-id-card" },
  { name: "Resume", iconClass: "fa-regular fa-file" },
  { name: "Portfolio", iconClass: "fa-solid fa-briefcase" },
  { name: "Contact", iconClass: "fa-regular fa-comment-dots" },
];

const contactLinks = [
  {
    name: "Github",
    url: "https://github.com/Gustavo-Ennes",
    iconClass: "fa-brands fa-github",
  },
  {
    name: "LinkedIn",
    url: "https://linkedin.com/in/gustavo-ennes",
    iconClass: "fa-brands fa-linkedin",
  },
  {
    name: "E-mail",
    url: "mailto:gustavo@ennes.dev?Subject=Hello%20Gustavo",
    iconClass: "fa-regular fa-envelope",
  },
  {
    name: "Telegram",
    url: "https://t.me/gustavoennes",
    iconClass: "fa-brands fa-telegram",
  },
];

export { sectionLinks, contactLinks };
